import React, { useState } from 'react'
import styles from './NewClientPage.module.scss'
import TitleUi from '../../components/ui/TitleUi/TilteUi'
import { Button, Form } from 'antd'
import { JsonForms } from '@jsonforms/react'
import { cellRegistryEntries } from '@great-expectations/jsonforms-antd-renderers'
import { customRenderers } from '../../components/JsonForm'
import FormWithTitleWrap from '../../components/ui/FormWithTitleWrap/FormWithTitleWrap'
import { IconInfoCircle, IconUserPlusBottom } from '../../utils/icons'
import { infoColumns } from './info.columns'
import { InfoItem } from './components/infoItem/InfoItem'
import { newCabinetFormSchema, newCabinetInitialValue, newCabinetUiSchema } from './schemas'
import { useAppDispatch } from '../../store/hooks'
import { createCabinet } from '../../store/cabinetsInfo/thunk'
import { CreateCabinetRequestDto } from '../../dto/cabinets/createCabinet/createCabinet.request.dto'
import { useNavigate } from 'react-router'
import { routersPath } from '../../router/routes-path'
import ButtonUi from '../../components/ui/ButtonUi/ButtonUi'

const NewClientPage = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const [errors, setErrors] = useState<any[]>([])

  const [data, setData] = useState<CreateCabinetRequestDto>(newCabinetInitialValue)

  const apiCall = async () => {
    try {
      const res = await dispatch(createCabinet(data))

      if (res.status === 201) {
        setData(newCabinetInitialValue)
        setErrors([])

        navigate(routersPath.CABINETS, { replace: true })
      }
    } catch (err: any) {
      setErrors([{ message: err.message || 'Не удалось создать кабинет' }])
    }
  }

  return (
    <div className={styles.container}>
      <Form
        className={styles.form}
        onSubmitCapture={(e) => {
          e.preventDefault()

          if (errors.length === 0) {
            apiCall()
          } else {
            console.log(errors)
          }
        }}
      >
        <div className={styles.pageHeader}>
          Добавление клиента
          <ButtonUi htmlType='submit'>
            <IconUserPlusBottom width='18' height='18' fill='var(--color-main)' />
            Создать кабинет
          </ButtonUi>
        </div>
        <div className={styles.pageContent}>
          <div className={styles.formsCol}>
            <JsonForms
              schema={newCabinetFormSchema}
              uischema={newCabinetUiSchema}
              data={data}
              renderers={customRenderers}
              cells={cellRegistryEntries}
              onChange={({ data, errors }) => {
                setData(data)
                setErrors(errors ?? [])
              }}
            />
          </div>

          <div className={styles.infoColumn}>
            <FormWithTitleWrap
              title='Рекомендации по заполнению'
              icon={<IconInfoCircle width='24' height='24' fill='var(--color-main)' />}
            >
              <>
                {infoColumns.map((item) => (
                  <InfoItem
                    key={item.id}
                    title={item.title}
                    icon={<item.icon width='24' height='24' fill='var(--color-main)' />}
                    description={item.description}
                  />
                ))}
              </>
            </FormWithTitleWrap>
          </div>
        </div>
      </Form>
    </div>
  )
}

export default NewClientPage
